import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { DialogActions, DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import { FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router';

export const Layout = () => {
  const history = useHistory();
  const { resource } = useMetaLayoutContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const { displayErrorMessage } = useSnackbarContext();


  async function handleOnContinue() {
    try {
      const [realAsset] = await resource.submit();
      realAsset.withRelationship(fr.relationships.navigate.name, (rel) => {
        return loadModalCollectionByLink(rel.link('related').url());
      }, () => {
        refreshPageContentCollection();
        clearModalCollection();
      });
    } catch (err) {
      displayErrorMessage(err, 'Error creating real asset');
    }
  }

  return (
    <>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent>
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'name'} />
          <MetaControlField attr={'ownerClientId'} />
          <MetaControlField attr={'value'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDPrimaryActionIconButton
          icon="chevronLeft"
          onClick={() => {
            history.goBack();
          }}
        />
        <FDPrimaryActionButton
          {...dataAttrs('continue-btn', resource)}
          label="Continue →"
          onClick={handleOnContinue}
          loading={false}
        />
      </DialogActions>
    </>
  );
};
